module.exports = __webpack_public_path__ + "assets/04f89317001cc9e8380f819423955db1.svg";